"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createCRUDActions(actionTypes, keyOfId) {
  return {
    updateOne: function updateOne(info, extra) {
      return {
        type: actionTypes.updateOne,
        info: info,
        extra: extra
      };
    },
    updateMany: function updateMany(docs, extras) {
      return {
        type: actionTypes.updateOne,
        infos: docs,
        extras: extras
      };
    },
    loadOne: function loadOne(info, loadTime, extra) {
      if (loadTime === void 0) {
        loadTime = new Date();
      }

      return {
        type: actionTypes.loadOne,
        info: info,
        loadTime: loadTime,
        extra: extra
      };
    },
    loadMany: function loadMany(infos, clearOthers, loadTime, extras) {
      if (loadTime === void 0) {
        loadTime = new Date();
      }

      return {
        type: actionTypes.loadMany,
        infos: infos,
        clearOthers: clearOthers,
        loadTime: loadTime,
        extras: extras
      };
    },
    deleteOne: function deleteOne(id) {
      var _a;

      return _a = {
        type: actionTypes.deleteOne
      }, _a[keyOfId] = id, _a;
    },
    deleteMany: function deleteMany(ids) {
      return {
        type: actionTypes.deleteMany,
        ids: ids
      };
    },
    clearAll: function clearAll() {
      return {
        type: actionTypes.clearAll
      };
    }
  };
}

exports.createCRUDActions = createCRUDActions;
exports.default = createCRUDActions;

exports.createCRUDActionTypes = function (singularName, pluralName) {
  singularName = singularName.toUpperCase();

  if (!pluralName) {
    pluralName = getPluralName(singularName);
  }

  return {
    updateOne: "UPDATE_" + singularName,
    updateMany: "UPDATE_MANY_" + pluralName,
    loadOne: "LOAD_" + singularName,
    loadMany: "LOAD_MANY_" + pluralName,
    deleteOne: "DELETE_" + singularName,
    deleteMany: "DELETE_MANY_" + pluralName,
    clearAll: "CLEAR_" + pluralName
  };
};

var getPluralName = function getPluralName(singular) {
  if (singular.length === 0) return "S";

  if (singular[singular.length - 1] === "Y") {
    if (singular.length >= 2 && isVowel(singular[singular.length - 2])) {
      return singular + "S";
    }

    return singular.substr(0, singular.length - 1) + "IES";
  }

  var lastLetter = singular[singular.length - 1];
  var last2Letters = singular.substr(singular.length - 2);

  if (lastLetter === "S" || lastLetter === "Z" || lastLetter === "X" || last2Letters === "SS" || last2Letters === "SH" || last2Letters === "CH") {
    return singular + "ES";
  }

  return singular + "S";
};

var isVowel = function isVowel(letter) {
  return letter === "A" || letter === "E" || letter === "I" || letter === "O" || letter === "U";
};